/*** IMPORTS FROM imports-loader ***/


/**
 * GIS Server APIs
 * A powerful suite of mapping, geospatial and location-based APIs for your applications and services.
 *
 * OpenAPI spec version: v1.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/ClientResource', 'model/ClientsResponse', 'model/ResponseClientResponse', 'model/ResponseListClientRoleResponse', 'model/ResponseObject'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/ClientResource'), require('../model/ClientsResponse'), require('../model/ResponseClientResponse'), require('../model/ResponseListClientRoleResponse'), require('../model/ResponseObject'));
  } else {
    // Browser globals (root is window)
    if (!root.GisServerApis) {
      root.GisServerApis = {};
    }
    root.GisServerApis.ClientsApi = factory(root.GisServerApis.ApiClient, root.GisServerApis.ClientResource, root.GisServerApis.ClientsResponse, root.GisServerApis.ResponseClientResponse, root.GisServerApis.ResponseListClientRoleResponse, root.GisServerApis.ResponseObject);
  }
}(this, function(ApiClient, ClientResource, ClientsResponse, ResponseClientResponse, ResponseListClientRoleResponse, ResponseObject) {
  'use strict';

  /**
   * Clients service.
   * @module api/ClientsApi
   * @version 1.0.0
   */

  /**
   * Constructs a new ClientsApi. 
   * @alias module:api/ClientsApi
   * @class
   * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the createClientForAccountV1 operation.
     * @callback module:api/ClientsApi~createClientForAccountV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseClientResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Create a new client for account.
     * @param {String} accountId The ID of the account you want to create the client for.
     * @param {Object} opts Optional parameters
     * @param {module:model/ClientResource} opts.clientModel The details of the client to be created. It includes a name, granted roles, client type and an optional allowed origins.
     * @param {module:api/ClientsApi~createClientForAccountV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseClientResponse}
     */
    this.createClientForAccountV1 = function(accountId, opts, callback) {
      opts = opts || {};
      var postBody = opts['clientModel'];

      // verify the required parameter 'accountId' is set
      if (accountId === undefined || accountId === null) {
        throw new Error("Missing the required parameter 'accountId' when calling createClientForAccountV1");
      }


      var pathParams = {
        'accountId': accountId
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = ResponseClientResponse;

      return this.apiClient.callApi(
        '/api/v1/accounts/{accountId}/clients', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the createClientV1 operation.
     * @callback module:api/ClientsApi~createClientV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseClientResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Create a new client.
     * @param {Object} opts Optional parameters
     * @param {module:model/ClientResource} opts.clientModel The details of the client to be created. It includes a name, granted roles, client type and an optional allowed origins.
     * @param {module:api/ClientsApi~createClientV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseClientResponse}
     */
    this.createClientV1 = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['clientModel'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = ResponseClientResponse;

      return this.apiClient.callApi(
        '/api/v1/clients', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the deleteClientsFromAccountV1 operation.
     * @callback module:api/ClientsApi~deleteClientsFromAccountV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseObject} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Delete the clients from an account.
     * @param {String} accountId The ID of the account you want to delete the clients from.
     * @param {Object} opts Optional parameters
     * @param {Array.<String>} opts.clientIds The IDs of the clients to be deleted.
     * @param {module:api/ClientsApi~deleteClientsFromAccountV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseObject}
     */
    this.deleteClientsFromAccountV1 = function(accountId, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'accountId' is set
      if (accountId === undefined || accountId === null) {
        throw new Error("Missing the required parameter 'accountId' when calling deleteClientsFromAccountV1");
      }


      var pathParams = {
        'accountId': accountId
      };
      var queryParams = {
      };
      var collectionQueryParams = {
        'clientIds': {
          value: opts['clientIds'],
          collectionFormat: 'multi'
        },
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = ResponseObject;

      return this.apiClient.callApi(
        '/api/v1/accounts/{accountId}/clients', 'DELETE',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the deleteClientsV1 operation.
     * @callback module:api/ClientsApi~deleteClientsV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseObject} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Delete the clients.
     * @param {Object} opts Optional parameters
     * @param {Array.<String>} opts.clientIds The IDs of the clients to be deleted.
     * @param {module:api/ClientsApi~deleteClientsV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseObject}
     */
    this.deleteClientsV1 = function(opts, callback) {
      opts = opts || {};
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
        'clientIds': {
          value: opts['clientIds'],
          collectionFormat: 'multi'
        },
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = ResponseObject;

      return this.apiClient.callApi(
        '/api/v1/clients', 'DELETE',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getClientByIdV1 operation.
     * @callback module:api/ClientsApi~getClientByIdV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseClientResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get a client for with a specified ID.
     * @param {String} clientId The ID of the client to query.
     * @param {module:api/ClientsApi~getClientByIdV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseClientResponse}
     */
    this.getClientByIdV1 = function(clientId, callback) {
      var postBody = null;

      // verify the required parameter 'clientId' is set
      if (clientId === undefined || clientId === null) {
        throw new Error("Missing the required parameter 'clientId' when calling getClientByIdV1");
      }


      var pathParams = {
        'clientId': clientId
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = ResponseClientResponse;

      return this.apiClient.callApi(
        '/api/v1/clients/{clientId}', 'GET',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getClientForAccountByIdV1 operation.
     * @callback module:api/ClientsApi~getClientForAccountByIdV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseClientResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get a client for accoutn with a specified ID.
     * @param {String} accountId The ID of the user account where the client gets from
     * @param {String} clientId The ID of the client to query.
     * @param {module:api/ClientsApi~getClientForAccountByIdV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseClientResponse}
     */
    this.getClientForAccountByIdV1 = function(accountId, clientId, callback) {
      var postBody = null;

      // verify the required parameter 'accountId' is set
      if (accountId === undefined || accountId === null) {
        throw new Error("Missing the required parameter 'accountId' when calling getClientForAccountByIdV1");
      }

      // verify the required parameter 'clientId' is set
      if (clientId === undefined || clientId === null) {
        throw new Error("Missing the required parameter 'clientId' when calling getClientForAccountByIdV1");
      }


      var pathParams = {
        'accountId': accountId,
        'clientId': clientId
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = ResponseClientResponse;

      return this.apiClient.callApi(
        '/api/v1/accounts/{accountId}/clients/{clientId}', 'GET',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getClientsForAccountV1 operation.
     * @callback module:api/ClientsApi~getClientsForAccountV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/ClientsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get clients for a specified account.
     * @param {String} accountId The ID of the account to query.
     * @param {module:api/ClientsApi~getClientsForAccountV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ClientsResponse}
     */
    this.getClientsForAccountV1 = function(accountId, callback) {
      var postBody = null;

      // verify the required parameter 'accountId' is set
      if (accountId === undefined || accountId === null) {
        throw new Error("Missing the required parameter 'accountId' when calling getClientsForAccountV1");
      }


      var pathParams = {
        'accountId': accountId
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = ClientsResponse;

      return this.apiClient.callApi(
        '/api/v1/accounts/{accountId}/clients', 'GET',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getClientsV1 operation.
     * @callback module:api/ClientsApi~getClientsV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/ClientsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get clients.
     * @param {module:api/ClientsApi~getClientsV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ClientsResponse}
     */
    this.getClientsV1 = function(callback) {
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = ClientsResponse;

      return this.apiClient.callApi(
        '/api/v1/clients', 'GET',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getRolesForClientV1 operation.
     * @callback module:api/ClientsApi~getRolesForClientV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseListClientRoleResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get available roles for creating client.
     * @param {module:api/ClientsApi~getRolesForClientV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseListClientRoleResponse}
     */
    this.getRolesForClientV1 = function(callback) {
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = ResponseListClientRoleResponse;

      return this.apiClient.callApi(
        '/api/v1/clients/roles', 'GET',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the updateClientForAccountV1 operation.
     * @callback module:api/ClientsApi~updateClientForAccountV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseClientResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Update the client for account.
     * @param {String} accountId The ID of account which the client ties to.
     * @param {String} clientId The ID of client to be updated.
     * @param {Object} opts Optional parameters
     * @param {module:model/ClientResource} opts.clientModel The information of the client to be updated.
     * @param {module:api/ClientsApi~updateClientForAccountV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseClientResponse}
     */
    this.updateClientForAccountV1 = function(accountId, clientId, opts, callback) {
      opts = opts || {};
      var postBody = opts['clientModel'];

      // verify the required parameter 'accountId' is set
      if (accountId === undefined || accountId === null) {
        throw new Error("Missing the required parameter 'accountId' when calling updateClientForAccountV1");
      }

      // verify the required parameter 'clientId' is set
      if (clientId === undefined || clientId === null) {
        throw new Error("Missing the required parameter 'clientId' when calling updateClientForAccountV1");
      }


      var pathParams = {
        'accountId': accountId,
        'clientId': clientId
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = ResponseClientResponse;

      return this.apiClient.callApi(
        '/api/v1/accounts/{accountId}/clients/{clientId}', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the updateClientV1 operation.
     * @callback module:api/ClientsApi~updateClientV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseClientResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Update the client.
     * @param {String} clientId The ID of client to be updated.
     * @param {Object} opts Optional parameters
     * @param {module:model/ClientResource} opts.clientModel The information of the client to be updated.
     * @param {module:api/ClientsApi~updateClientV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseClientResponse}
     */
    this.updateClientV1 = function(clientId, opts, callback) {
      opts = opts || {};
      var postBody = opts['clientModel'];

      // verify the required parameter 'clientId' is set
      if (clientId === undefined || clientId === null) {
        throw new Error("Missing the required parameter 'clientId' when calling updateClientV1");
      }


      var pathParams = {
        'clientId': clientId
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = ResponseClientResponse;

      return this.apiClient.callApi(
        '/api/v1/clients/{clientId}', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));

